const EARTH_RADIUS_MI = 3958.8;
const toRad = (d) => (d * Math.PI) / 180;

export const distanceMi = (a, b) => {
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const h =
    Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_MI * Math.asin(Math.sqrt(h));
};

// Inverse-distance weights over stations ranked by distance.
export const idwWeights = (ranked, power) => {
  if (ranked[0].distanceMi < 0.25) return [{ id: ranked[0].station.id, weight: 1 }];
  const raw = ranked.map((r) => ({ id: r.station.id, weight: 1 / r.distanceMi ** power }));
  const total = raw.reduce((s, r) => s + r.weight, 0);
  return raw.map((r) => ({ ...r, weight: r.weight / total }));
};
